import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import Version from "../../Version/Version";
import Environment from "../../Environment/Environment";

export default function* checkVersion(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_CHECK_VERSION
    });

    if (Environment.isRenderedByWebpack() === false) {
      const version = yield call(Version.getFrontendVersion);

      console.log("========================");
      console.log("currentVersion: ", Version.version);
      console.log("latestVersion: ", version);
      console.log("========================");

      if (version !== Version.version) {
        yield put({
          type: Constants.NEW_VERSION_IGNORE
        });

        return window.location.reload();
      }
    }

    yield put({
      type: Constants.PAGE_CHECK_VERSION_SUCCESS
    });
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_CHECK_VERSION_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchCheckVersion() {
  yield takeEvery(Constants.PAGE_CHECK_VERSION_START, checkVersion);
}
